import React from 'react';
import './WhatsAppButton.css';

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ 
  phoneNumber = '7617610660',
  message = 'Hello! I need assistance.' 
}) => {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-button" onClick={handleClick}>
      <svg 
        viewBox="0 0 32 32" 
        xmlns="http://www.w3.org/2000/svg"
        className="whatsapp-icon"
      >
        <path 
          fill="currentColor"
          d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.973 0-7.51 6.11-13.62 13.62-13.62s13.62 6.11 13.62 13.62-6.11 13.62-13.62 13.62zM21.305 19.26c-0.346-0.174-2.049-1.007-2.366-1.123-0.316-0.117-0.547-0.174-0.776 0.174s-0.892 1.123-1.094 1.347c-0.201 0.231-0.403 0.26-0.748 0.087-0.346-0.174-1.461-0.539-2.785-1.722-1.031-0.922-1.727-2.053-1.929-2.398-0.201-0.346-0.022-0.533 0.152-0.705 0.156-0.155 0.346-0.403 0.518-0.605 0.174-0.201 0.231-0.346 0.346-0.577 0.117-0.231 0.058-0.433-0.028-0.605-0.087-0.174-0.776-1.87-1.063-2.565-0.281-0.672-0.567-0.58-0.776-0.591-0.201-0.010-0.431-0.012-0.662-0.012s-0.605 0.087-0.922 0.433c-0.316 0.346-1.207 1.18-1.207 2.873s1.236 3.333 1.41 3.561c0.174 0.231 2.413 3.782 5.898 5.3 3.486 1.518 3.486 1.011 4.117 0.951 0.631-0.061 2.049-0.836 2.337-1.645 0.289-0.808 0.289-1.501 0.201-1.645-0.087-0.146-0.318-0.231-0.662-0.403z"
        />
      </svg>
    </div>
  );
};

export default WhatsAppButton;
